import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../lib/api';
import Header from '../components/Header';
import { Button } from '../components/ui/button';
import { Lock, Hash } from 'lucide-react';
import { AuthField, errText } from '../components/AuthBits';

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const linkToken = params.get('token') || '';
  const identifier = params.get('identifier') || '';
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error('6 caractères minimum');
    if (password !== confirm) return toast.error('Les mots de passe ne correspondent pas');
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token: linkToken || code.trim(), password, identifier });
      toast.success('Mot de passe modifié. Connectez-vous.');
      nav('/login');
    } catch (err) { toast.error(errText(err) || 'Lien ou code invalide'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-14">
        <div className="card-elev rounded-3xl p-7">
          <h1 className="font-display text-3xl font-extrabold">Nouveau mot de passe</h1>
          <form onSubmit={submit} className="mt-6 space-y-3">
            {!linkToken && <AuthField icon={<Hash className="h-4 w-4" />} type="text" value={code} onChange={setCode} placeholder="Code reçu par SMS (6 chiffres)" testid="reset-code" />}
            <AuthField icon={<Lock className="h-4 w-4" />} type="password" value={password} onChange={setPassword} placeholder="Nouveau mot de passe" testid="reset-password" autoComplete="new-password" />
            <AuthField icon={<Lock className="h-4 w-4" />} type="password" value={confirm} onChange={setConfirm} placeholder="Confirmer le mot de passe" testid="reset-confirm" autoComplete="new-password" />
            <Button disabled={busy} type="submit" data-testid="reset-submit" className="w-full btn-brand text-white py-6 rounded-xl font-bold">Changer le mot de passe</Button>
          </form>
          <div className="mt-6 text-center text-sm text-slate-400">
            <Link to="/login" data-testid="back-to-login" className="text-sky-400 hover:underline">Retour à la connexion</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
